import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@descope/react-sdk';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import TransferPage from './pages/TransferPage';
import ProtectPage from './pages/ProtectPage';
import CopilotPage from './pages/CopilotPage';
import RemediationPage from './pages/RemediationPage';
import NotFoundPage from './pages/NotFoundPage';
import config from './config';
import { apiClient } from './services/APIClient';
import { descopeConfig } from './utils/descopeClient';
import './styles/main.css';
const App = () => {
    const [isWidgetLoaded, setIsWidgetLoaded] = useState(false);
    // Debug Descope configuration
    useEffect(() => {
        console.log('🔐 Descope Configuration:', descopeConfig);
        console.log('🔐 Project ID:', config.descopeProjectId);
        // Check if localStorage is available
        if (typeof window !== 'undefined') {
            console.log('🔐 localStorage available:', !!window.localStorage);
            console.log('🔐 Current localStorage keys:', Object.keys(localStorage));
        }
    }, []);
    // Fetch and set JWT token
    useEffect(() => {
        const fetchJwtToken = async () => {
            try {
                const response = await apiClient.fetch('/api/jwt-token');
                window.CONVERSATION_JWT_TOKEN = response.jwtToken;
                console.log('🔒 JWT token set to window object');
            }
            catch (error) {
                console.error('Failed to fetch JWT token:', error);
            }
        };
        fetchJwtToken();
    }, []);
    return (_jsx(AuthProvider, { projectId: config.descopeProjectId, persistTokens: true, children: _jsx(Router, { children: _jsx(Layout, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(ProtectedRoute, { children: _jsx(DashboardPage, {}) }) }), _jsx(Route, { path: "/transfer", element: _jsx(ProtectedRoute, { children: _jsx(TransferPage, {}) }) }), _jsx(Route, { path: "/protect", element: _jsx(ProtectedRoute, { children: _jsx(ProtectPage, {}) }) }), _jsx(Route, { path: "/copilot", element: _jsx(ProtectedRoute, { children: _jsx(CopilotPage, {}) }) }), _jsx(Route, { path: "/remediation", element: _jsx(ProtectedRoute, { children: _jsx(RemediationPage, {}) }) }), _jsx(Route, { path: "*", element: _jsx(NotFoundPage, {}) })] }) }) }) }));
};
export default App;
